<script>
import { ArrowUpIcon, HeartIcon, EyeIcon, ShoppingCartIcon } from "vue-feather-icons";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import Navbar from "@/view/front/components/navbar";
// import Switcher from "@/view/front/components/switcher";
import Footer from "@/view/front/components/footer";
import API from "@/core/api";
import IndexService from "@/MainServices/IndexService.js";
import Button from '../../pages/vue-bootstrap/Button.vue';
import Skeleton from "@/view/front/components/skeleton_home";

/**
 * Shop-product-detail component
 */
export default {
  data() {
    return {
      countval: 1,
      API: API.API_HOME,
      searchedUniversity:null,
      search:false,
      universites:[],
      filterUniversitesData: [],
      loading: true,
      searchUniByCity: "",
      show_load_more: true,
    };
  },
  components: {
    Navbar,
    // Switcher,
    Footer,
    ArrowUpIcon,
    Skeleton
  },
  methods: {
      onImageLoadFailure(event) {
        event.target.src = "/images/uni_demo_profile.png";
      },
      filterUniversties(e)
      {
       this.filterUniversitesData =   this.universites.filter((el) => {
           return el.value == e
       }) 
       this.search = true;
      },
      clearSearch()
      {
          this.searchedUniversity = null;
          this.search = false;
      }
  },
  mounted() {

    if(this.$session.exists("searchUniByCity")) {

      this.searchUniByCity = this.$session.get("searchUniByCity")
      this.$session.remove("searchUniByCity")

      IndexService.getUniversitesWithListingsByCity(this.searchUniByCity)
      .then((response) => {
        response.data.map((el) => {
          this.universites.push({
            value: el.id,
            text: el.name,
            image_path: el.image_path,
            user_slug : el.user_slug
          })
          this.loading = false;
        });
      });
    }
    else {
      IndexService.getUniversitesWithListings(
     
        ).then((response) => {

          response.data.map((el) => {
            this.universites.push({value: el.id, text: el.name, image_path: el.image_path, user_slug : el.user_slug})
            this.loading = false;
          });
        });
    }

    
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="d-table w-100">
      <div class="main_top_uni_bg_hero">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12 text-center">
              <div class="page-next-level">
                <h4 class="uni-top-im-title" :class="{r_top_im_text_word_spacing: searchUniByCity == ''}">
                  {{searchUniByCity != "" ? 'Universities in' : ''}} 
                  <span class="text-success">
                    {{searchUniByCity != "" ? searchUniByCity : 'my'}}
                  </span> 
                  {{searchUniByCity != "" ? '' : 'Universities'}}
                </h4>
                <p class="uni-top-im-ptext">Select your favourite <span class="text-success">University</span> and <br> apply in your dream course.</p>
                <div class="page-next"></div>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
        <!--end container-->
      </div>
    </section>
    <!--end section-->
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!-- Hero End -->

        <!-- Course list Start -->
    <section class="section">
        <div class="container r_px_custom">
           
            <div class="justify-content-center">
                 
                 <div class="flex-show  r_commbbo">
                <v-autocomplete 
                  :items="universites" 
                  v-model="searchedUniversity" 
                  label="Search by university name" 
                  @change="filterUniversties($event)" 
                  class="form-control mb-2 mr-sm-2 header-input"></v-autocomplete>
                <button type="button" class="btn btn-success mb-2 header-uni-clear-btn font-weight-bold" @click="clearSearch">Clear</button>
                </div>
                <!-- <div class="col-12">
                    <div class="section-title text-center mb-1 pb-1">
                        <p class="text-muted para-desc mb-0 mx-auto">Select your favourite <span class="text-primary font-weight-bold">University</span> and apply in your dream course.</p>
                    </div>
                </div> -->
                <!--end col-->
            </div>
            <!--end row-->
                 <Skeleton v-if="loading" /> 

            <div class="row r_row_uni_cards" v-if="!search">
                <div class="col mt-4 pt-2 mb-5" v-for="(university, index) in universites" :key="index">
                    <div class="explore-feature border-0 rounded text-center r_card_f_uni">
                        <div class="r_card_f_uni_body">
                            <div class="icon d-inline-block">
                              <img
                                @error="onImageLoadFailure($event)"
                                :src="API+`${university.image_path}` || ''"
                                class="img-fluid rounded-top mx-auto r_card_f_uni_body_img"
                                alt=""
                              />
                            </div>
                            <div class="pt-5">
                                <h5 class="r_card_f_uni_name">{{university.text}}</h5>
                            </div>
                            
                        </div>
                    </div>
                    <div class="pt-3">
                      <router-link :to="{name: 'UniCourses',  params: { uni_name: university.user_slug.toLowerCase().trim(), uni_id: university.value }}" class="btn btn-outline-primary btn-sm r_card_f_uni_btn">View Courses</router-link>
                    </div>
                </div>
                <!--end col-->
                <!--end col-->
            </div>
            
            <!--end row-->
            <div class="row r_row_uni_cards" v-if="search">
                <div class="col mt-4 pt-2 mb-5" v-for="(university, index) in filterUniversitesData" :key="index">
                    <div class="explore-feature border-0 rounded text-center r_card_f_uni">
                        <div class="r_card_f_uni_body">
                            <div class="icon d-inline-block">
                              <img
                                :src='API+`${university.image_path}`'
                                class="img-fluid rounded-top mx-auto r_card_f_uni_body_img"
                                alt=""
                              />
                            </div>
                            <div class="pt-5">
                                <h5 class="r_card_f_uni_name">{{university.text}}</h5>
                            </div>
                        </div>
                    </div>
                    
                    <div class="pt-3">
                      <router-link :to="{name: 'UniCourses',  params: { uni_name: university.user_slug.toLowerCase().trim() }}" class="btn btn-outline-primary btn-sm r_card_f_uni_btn">View Courses</router-link>
                    </div>
                </div>
                <!--end col-->
                <!--end col-->
            </div>
            <!--end row-->
        </div>
        <!--end container-->
    </section>
    <!--end section-->

    <Footer />
    <!-- Footer End -->
    <!-- <Switcher /> -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style scoped>
.text-success {
    color: rgb(46, 202, 139) !important;
}
</style>
